module.exports = __webpack_public_path__ + "img/logo.61b1c299.png";